var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3V7.5H12.75",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15V10.5H5.25",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6325 6.75C3.01288 5.67508 3.65935 4.71405 4.5116 3.95656C5.36385 3.19907 6.3941 2.66982 7.50621 2.41819C8.61833 2.16656 9.77607 2.20075 10.8714 2.51758C11.9667 2.8344 12.9639 3.42353 13.77 4.23L17.25 7.5M0.75 10.5L4.23 13.77C5.03606 14.5765 6.03328 15.1656 7.12861 15.4824C8.22393 15.7992 9.38167 15.8334 10.4938 15.5818C11.6059 15.3302 12.6361 14.8009 13.4884 14.0434C14.3407 13.2859 14.9871 12.3249 15.3675 11.25",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.82c4a2d809d953f334536d0466deadf2.svg";
export { ForwardRef as ReactComponent };